export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return '99999';
    }

    birthdate() {
        return '2999-19-39';
    }
}
